var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-dialog',{staticClass:"table",attrs:{"title":"点击广告免费下载","visible":_vm.visible},on:{"update:visible":function($event){_vm.visible=$event},"close":_vm.closeDialog}},[_c('span',{staticClass:"activityName"},[_vm._v(_vm._s(_vm.activityName))]),_c('img',{staticClass:"img",attrs:{"src":_vm.imgUrl,"alt":""},on:{"click":_vm.clickAd}})])
}
var staticRenderFns = []

export { render, staticRenderFns }